import { c as r } from "./classof-raw.js";
import { f as n } from "./function-uncurry-this.js";
var o = function o(_o) {
  if ("Function" === r(_o)) return n(_o);
};
export { o as f };